
export const Subscriptions = [
    {
        name: 'Basic',
        key: 'Basic',
        value: 'BASIC',
        metadata: {
            project: {
                limit: [
                    { label: 'Total Projects', key: 'total_projects', value: 1 }
                ],
                availability: [
                    { label: 'Current Projects', key: 'current', value: false },
                    { label: 'Quotes', key: 'quotes', value: true }
                ]
            },
            users: {
                limit: [
                    { label: 'Total Users', key: 'total_users', value: 1 }
                ]
            },
            workforce: {
                availability: [
                    { label: 'Timesheet Menu', key: 'timesheet_side_menu', value: false },
                    { label: 'Timesheet Input Menu', key: 'timesheet_input_menu', value: false },
                    { label: 'Schedule Menu', key: 'schedule_side_menu', value: false }
                ]
            },
            inventory: {
                availability: [
                    { label: 'Inventory Menu', key: 'inventory_side_menu', value: true },
                    { label: 'Receive Stock', key: 'receive_stock', value: false },
                ]
            },
            asset: {
                availability: [
                    { label: 'Asset Management Menu', key: 'asset_side_menu', value: false }
                ]
            },
            accounting: {
                availability: [
                    { label: 'Enable Integration', key: 'xero_integration', value: false },
                    { label: 'Export (Push)', key: 'xero_push', value: false },
                    { label: 'Import (Pull)', key: 'xero_pull', value: false },
                    { label: 'Enable Integration', key: 'qbo_integration', value: false },
                    { label: 'Export (Push)', key: 'qbo_push', value: false },
                    { label: 'Import (Pull)', key: 'qbo_pull', value: false },
                    { label: 'Enable Integration', key: 'myob_integration', value: false },
                    { label: 'Export (Push)', key: 'myob_push', value: false },
                    { label: 'Import (Pull)', key: 'myob_pull', value: false }
                ]
            }
        }
    },
    {
        name: 'Pro',
        key: 'Pro',
        value: 'PRO',
        metadata: {
            project: {
                limit: [
                    { label: 'Total Projects', key: 'total_projects', value: 5 }
                ],
                availability: [
                    { label: 'Current Projects', key: 'current', value: true },
                    { label: 'Quotes', key: 'quotes', value: true }
                ]
            },
            users: {
                limit: [
                    { label: 'Total Users', key: 'total_users', value: 3 }
                ]
            },
            workforce: {
                availability: [
                    { label: 'Timesheet Menu', key: 'timesheet_side_menu', value: true },
                    { label: 'Timesheet Input Menu', key: 'timesheet_input_menu', value: true },
                    { label: 'Schedule Menu', key: 'schedule_side_menu', value: true }
                ]
            },
            inventory: {
                availability: [
                    { label: 'Inventory Menu', key: 'inventory_side_menu', value: true },
                    { label: 'Receive Stock', key: 'receive_stock', value: true },
                ]
            },
            asset: {
                availability: [
                    { label: 'Asset Management Menu', key: 'asset_side_menu', value: true }
                ]
            },
            accounting: {
                availability: [
                    { label: 'Enable Integration', key: 'xero_integration', value: true },
                    { label: 'Export (Push)', key: 'xero_push', value: false },
                    { label: 'Import (Pull)', key: 'xero_pull', value: true },
                    { label: 'Enable Integration', key: 'qbo_integration', value: true },
                    { label: 'Export (Push)', key: 'qbo_push', value: false },
                    { label: 'Import (Pull)', key: 'qbo_pull', value: true },
                    { label: 'Enable Integration', key: 'myob_integration', value: true },
                    { label: 'Export (Push)', key: 'myob_push', value: false },
                    { label: 'Import (Pull)', key: 'myob_pull', value: true }
                ]
            }
        }
    },
    {
        name: 'Custom',
        key: 'Custom',
        value: 'CUSTOM',
        metadata: {
            project: {
                limit: [
                    { label: 'Total Projects', key: 'total_projects', value: 10 }
                ],
                availability: [
                    { label: 'Current Projects', key: 'current', value: true },
                    { label: 'Quotes', key: 'quotes', value: true }
                ]
            },
            users: {
                limit: [
                    { label: 'Total Users', key: 'total_users', value: 5 }
                ]
            },
            workforce: {
                availability: [
                    { label: 'Timesheet Menu', key: 'timesheet_side_menu', value: true },
                    { label: 'Timesheet Input Menu', key: 'timesheet_input_menu', value: true },
                    { label: 'Schedule Menu', key: 'schedule_side_menu', value: true }
                ]
            },
            inventory: {
                availability: [
                    { label: 'Inventory Menu', key: 'inventory_side_menu', value: true },
                    { label: 'Receive Stock', key: 'receive_stock', value: true },
                ]
            },
            asset: {
                availability: [
                    { label: 'Asset Management Menu', key: 'asset_side_menu', value: true }
                ]
            },
            accounting: {
                availability: [
                    { label: 'Enable Integration', key: 'xero_integration', value: true },
                    { label: 'Export (Push)', key: 'xero_push', value: true },
                    { label: 'Import (Pull)', key: 'xero_pull', value: true },
                    { label: 'Enable Integration', key: 'qbo_integration', value: true },
                    { label: 'Export (Push)', key: 'qbo_push', value: true },
                    { label: 'Import (Pull)', key: 'qbo_pull', value: true },
                    { label: 'Enable Integration', key: 'myob_integration', value: true },
                    { label: 'Export (Push)', key: 'myob_push', value: true },
                    { label: 'Import (Pull)', key: 'myob_pull', value: true }
                ]
            }
        }
    },
]

export const minifySubscription = (subscription_metadata = {}, isGlobalUser = false, featureFlags = {}) => {
    const rawData = subscription_metadata?.raw || subscription_metadata;

    let entitlements = {
        currentProject: isGlobalUser,
        quotesProject: isGlobalUser,
        timesheetMenu: isGlobalUser,
        scheduleMenu: isGlobalUser,
        timesheetInputMenu: isGlobalUser,
        inventoryMenu: isGlobalUser,
        assetMenu: isGlobalUser,
        receiveStock: isGlobalUser,
        accountingIntegration: isGlobalUser,
        accountingPush: isGlobalUser,
        accountingPull: isGlobalUser,
        xeroIntegration: isGlobalUser,
        xeroPush: isGlobalUser,
        xeroPull: isGlobalUser,
        qboIntegration: isGlobalUser,
        qboPush: isGlobalUser,
        qboPull: isGlobalUser,
        myobIntegration: isGlobalUser,
        myobPush: isGlobalUser,
        myobPull: isGlobalUser,
        totalUsers: 0,
        totalProjects: 0
    };
    for (const key in rawData) {
        for (let itr of (rawData[key]?.availability || [])) {
            switch (itr.key) {
                case 'current': entitlements.currentProject ||= Boolean(itr.value); break;
                case 'quotes': entitlements.quotesProject ||= Boolean(itr.value); break;
                case 'timesheet_side_menu': entitlements.timesheetMenu ||= Boolean(itr.value); break;
                case 'timesheet_input_menu': entitlements.timesheetInputMenu ||= Boolean(itr.value); break;
                case 'schedule_side_menu': entitlements.scheduleMenu ||= Boolean(itr.value); break;
                case 'inventory_side_menu': entitlements.inventoryMenu ||= Boolean(itr.value); break;
                case 'receive_stock': entitlements.receiveStock ||= Boolean(itr.value); break;
                case 'asset_side_menu': entitlements.assetMenu ||= Boolean(itr.value); break;
                case 'accounting_integration': entitlements.accountingIntegration = Boolean(itr.value); break;
                case 'accounting_push': entitlements.accountingPush = Boolean(itr.value); break;
                case 'accounting_pull': entitlements.accountingPull = Boolean(itr.value); break;
                case 'xero_integration': entitlements.xeroIntegration = Boolean(itr.value); break;
                case 'xero_push': entitlements.xeroPush = Boolean(itr.value); break;
                case 'xero_pull': entitlements.xeroPull = Boolean(itr.value); break;
                case 'qbo_integration': entitlements.qboIntegration = Boolean(itr.value); break;
                case 'qbo_push': entitlements.qboPush = Boolean(itr.value); break;
                case 'qbo_pull': entitlements.qboPull = Boolean(itr.value); break;
                case 'myob_integration': entitlements.myobIntegration = Boolean(itr.value); break;
                case 'myob_push': entitlements.myobPush = Boolean(itr.value); break;
                case 'myob_pull': entitlements.myobPull = Boolean(itr.value); break;
                default: break;
            }
        }
        for (let itr of (subscription_metadata[key]?.limit || [])) {
            switch (itr.key) {
                case 'total_users': entitlements.totalUsers = Number(itr.value); break;
                case 'total_projects': entitlements.totalProjects = Number(itr.value); break;
                default: break;
            }
        }
    }

    // Backward compatibility for accounts without explicit platform-specific keys
    const hasPlatformKeys = (rawData?.accounting?.availability || []).some(platform =>
        ['xero_', 'qbo_', 'myob_'].some(prefix =>
            platform.key.startsWith(prefix)
        )
    );
    if (!hasPlatformKeys) {
        const hasAccountingSection = Boolean(rawData?.accounting);
        const isAccountingEnabled = hasAccountingSection ? Boolean(entitlements.accountingIntegration) : true;

        entitlements.xeroIntegration = isAccountingEnabled;
        entitlements.qboIntegration = isAccountingEnabled;
        entitlements.myobIntegration = isAccountingEnabled;
        entitlements.xeroPush = isAccountingEnabled ? entitlements.accountingPush : false;
        entitlements.qboPush = isAccountingEnabled ? entitlements.accountingPush : false;
        entitlements.myobPush = isAccountingEnabled ? entitlements.accountingPush : false;
        entitlements.xeroPull = isAccountingEnabled ? entitlements.accountingPull : false;
        entitlements.qboPull = isAccountingEnabled ? entitlements.accountingPull : false;
        entitlements.myobPull = isAccountingEnabled ? entitlements.accountingPull : false;
    }

    // Apply feature flag overrides via AND condition
    const isXeroFlagEnabled = featureFlags.xero_integration !== false;
    const isQboFlagEnabled = featureFlags.quickbooks_integration !== false;
    const isMyobFlagEnabled = featureFlags.myob_integration !== false;

    entitlements.xeroIntegration = entitlements.xeroIntegration && isXeroFlagEnabled;
    entitlements.xeroPush = entitlements.xeroPush && isXeroFlagEnabled;
    entitlements.xeroPull = entitlements.xeroPull && isXeroFlagEnabled;

    entitlements.qboIntegration = entitlements.qboIntegration && isQboFlagEnabled;
    entitlements.qboPush = entitlements.qboPush && isQboFlagEnabled;
    entitlements.qboPull = entitlements.qboPull && isQboFlagEnabled;

    entitlements.myobIntegration = entitlements.myobIntegration && isMyobFlagEnabled;
    entitlements.myobPush = entitlements.myobPush && isMyobFlagEnabled;
    entitlements.myobPull = entitlements.myobPull && isMyobFlagEnabled;

    entitlements.accountingIntegration = Boolean(entitlements.xeroIntegration || entitlements.qboIntegration || entitlements.myobIntegration);
    entitlements.accountingPush = Boolean(entitlements.xeroPush || entitlements.qboPush || entitlements.myobPush);
    entitlements.accountingPull = Boolean(entitlements.xeroPull || entitlements.qboPull || entitlements.myobPull);

    return entitlements;
};